export default {
    title: 'Як це працює?',
    description: 'Дивись відео та дізнайся як працює сервіс за 45 секунд',
    howDoesItWorkStepBlockOneTitle: 'Створюєш тендер в декілька кліків',
    howDoesItWorkStepBlockOneDescription: 'Розміщуй будь-яке своє бажання: вкажи у довільній формі опис, характеристики, ціну, або завантаж фото.',
    howDoesItWorkStepBlockTwoTitle: 'Отримуй пропозиції',
    howDoesItWorkStepBlockTwoDescription: 'Тисячі продавців побачать твій тендре та зроблять тобі свої пропозиції. Чим оригінальніша та змістовніша пропозиція, тим більший її рейтинг.',
    howDoesItWorkStepBlockThreeTitle: 'Обирай найкращу',
    howDoesItWorkStepBlockThreeDescription: 'Обирай ту, яка подобається саме тобі: пиши продавцю та узгоджуйте деталі в чаті.',
}